import axios from 'axios'
import Fingerprint2 from "fingerprintjs2";

const ajax = axios.create()

var hex_chr = "0123456789abcdef";

function rhex(num) {
    var str = "";
    for (let j = 0; j <= 3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) +
            hex_chr.charAt((num >> (j * 8)) & 0x0F);
    return str;
}

function str2blks_MD5(str) {
    var i
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    for (let i = 0; i < nblk * 16; i++) blks[i] = 0;
    for (let i = 0; i < str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
    blks[i >> 2] |= 0x80 << ((i % 4) * 8);
    blks[nblk * 16 - 2] = str.length * 8;
    return blks;
}

function add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
}

function rol(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t) {
    return add(rol(add(add(a, q), add(x, t)), s), b);
}

function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | (~d)), a, b, x, s, t);
}

function MD5(str) {
    var x = str2blks_MD5(str);
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for (let i = 0; i < x.length; i += 16) {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i + 10], 17, -42063);
        b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = hh(a, b, c, d, x[i + 5], 4, -378558);
        d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = add(a, olda);
        b = add(b, oldb);
        c = add(c, oldc);
        d = add(d, oldd);
    }
    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
}
function uuid() {
  var str = ""
  for (let i in navigator) {
      let temp = JSON.stringify(navigator[i])
      if (temp) {
          temp = temp.split("").reverse().join("")
          str+=temp
      }
  }
  var md = MD5(str)
  return md
}
if (localStorage.getItem("fp")){
    var fp =localStorage.getItem("fp")
} else {
    var fp = uuid();
}
localStorage.setItem("fp", fp);
sessionStorage.setItem("fp", fp);


// get_fingerprint_sign()
// 设置拦截器
ajax.interceptors.request.use(config => {
  // 将token存放在请求头中
  config.headers.common['Authentication'] = localStorage.getItem('login_info')
  // if (!fp) {
  //   return config
  // }
  // 传入浏览器指纹，确定用户具有唯一性
  config.headers.common['Authentication-Fp'] = fp
  return config
})

ajax.interceptors.response.use(resp => {
  // 数据响应后关闭加载
  // Indicator.close()
  // 进行全局错误处理
  if (resp.status === 200) {
    if (resp.data.code === 4001) {
        localStorage.removeItem('token')
        location.href="/"
    }
    return resp.data
  } else {
    return {
      status: 400,
      msg: '网络错误'
    }
  }
})


// ============================用户=========================
// 获取验证码图片
export const getVerificationCode = (time) => ajax.get(`/api/user/captcha/?time=${time}`)
// 登陆
export const getLogin = (param) => ajax.post('/api/user/login/', param)
// 退出系统
export const getLogout = () => ajax.get('/api/user/logout/')
// 注册
export const getRegister = (param) => ajax.post('/api/user/register/', param)
// 验证是否登陆有效
export const getVerify = () => ajax.get('/api/user/check_token_result/')
// 获取个人信息
export const getUserInfo = () => ajax.get('/api/user/get_token_info/')
// 修改个人资料
export const postChangeInfo = (param) => ajax.post('/api/user/update_profile/', param)
// 根据用户信息，判断是否可以进入到资源页面，并且返回资源数据
export const getResult = () => ajax.get('/api/user/check_user/')
// 修改密码
export const postChangePwd = (param) => ajax.post('/api/user/update_pwd/', param)
// 找回密码
export const postResetPwd = (param) => ajax.post('/api/user/forget_email_pwd/', param)
// 重置密码
export const postChangeResetPwd = (param) => ajax.post('/api/user/update_forget_email_pwd/', param)
// 请求新消息
export const getNewInfoList = () => ajax.get('/api/operation/get_u_notice/')
// 阅读--通知状态
export const postReadState = (param) => ajax.post('/api/operation/read_notice/', param)
// 关闭弹出框，收拢所有通知数据
export const getClosePopoverEvent = () => ajax.get(`/api/operation/close_popover_event/`)

// ============================数据请求======================
// 获取资源列表所有数据
export const getMainData = () => ajax.get('/api/src/get_front_src_info/')
// 获取用户发票信息
export const getInvoiceData = () => ajax.get('/api/trade/invoice/')
// 保存用户发票信息
export const postSaveInvoice = (param) => ajax.post('/api/trade/invoice/', param)
// 获取支付数据
export const getTradeType = () => ajax.get(`/api/trade/get_trade_type_info/?t=front`)
// 获取支付二维码
// export const postPayQrCode = (data) => ajax.post(`/api/trade/get_pay_qr_code/`, data)
export const postPayQrCode = (data) => ajax.post(`/api/trade/get_pay_new_qr_code/`, data)
// 轮询订单状态
export const getOrderStatus = (order_id, pay_type) => ajax.get(`/api/trade/get_order_status/?order_id=${order_id}&pay_type=${pay_type}&_time=${new Date().getTime()}`)
// 卡密充值
export const postCardRecharge = (data) => ajax.post(`/api/trade/card_recharge/`, data)
// 获取当前用户的财务级记录
export const getUserFinancial = () => ajax.get(`/api/operation/get_u_financial/`)
// 申请发票 apply_invoice
export const postApplyInvoice = (data) => ajax.post(`/api/operation/apply_invoice/`, data)

// 获取公告进行显示
export const getAnnouncements = () => ajax.get(`/api/operation/get_announcement/`)
// 添加用户访问数据库行为
export const postAddUserOperation = (data) => ajax.post(`/api/operation/add_user_operation/`, data)
// 获取用户访问权限
export const postUserCondition = (param) => ajax.post(`/api/src/get_user_condition/`, param)
// 获取用户访问权限
export const postResLink = (param) => ajax.post(`/api/src/get_reslink/`, param)

// 修复资源id
export const getrepair = (id) => ajax.get(`/api/src/repair_id/?id=${id}`)

export const getInvoiceProvide = (t = undefined, v = undefined) => ajax.get(`/api/operation/invoice_provide/?t=${t}&v=${v}`)

// 获取html数据
export const getHtml = (filename) => ajax.get(`/api/operation/send_html/?filename=${filename}`)

// 药典树形结构数据
export const postPharmaTree = (param) => ajax.post(`/api/operation/Pharmacopeia/`, param)
// 药典查询数据
export const getPharmaData = (tid, name, source, versions, page) => ajax.get(`/api/operation/Pharmacopeia/?tid=${tid}&name=${name}&source=${source}&versions=${versions}&page=${page}`)
// 药典查询药典数据历史
export const getPharmaHistoryData = () => ajax.get(`/api/operation/Pharmacopeia/?history_data=1`)
// 全文数据查询
export const postFullTextQuery = (param) => ajax.post(`/api/operation/queryfulltext/`, param)
// 全文文件查看历史
export const postFullTextHistory = (param) => ajax.post(`/api/operation/queryfulltexthistory/`, param)